import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./en/translations.json";
import de from "./de/translations.json";
import es from "./es/translations.json";
import ja from "./ja/translations.json";
import ko from "./ko/translations.json";

const settings = {
  fallbackLng: "en",
  debug: !(__NODE_ENV__ === "production") || true,
  interpolation: {
    escapeValue: false,
  },
  resources: {
    en,
    es,
    de,
    ja,
    ko,
  },
};

// When we're running locally, throw an error and break the site if a
// translation key is missing.
if (__NODE_ENV__ !== "production") {
  settings.saveMissing = true;
  settings.missingKeyHandler = function(lng, ns, key, fallback) {
    console.error("Key Missing!", lng, ns, key, fallback);
  };
}

const i18nInstance = i18n.use(LanguageDetector).init(settings);
window.i18n = i18nInstance;

export default i18n;
